import { EXPO_MANIFEST_EXTRA } from '../../../constant/index'

// eslint-disable-next-line no-undef
const API_URL = (typeof TRAINING_API_ENDPOINT !== 'undefined' ? TRAINING_API_ENDPOINT : EXPO_MANIFEST_EXTRA.apiUrl)
export default API_URL
